import { useState } from "react";
import { Box, Card, CardContent, Typography, TextField, Button, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Nlayout from "./Nlayout";

function Paneltipeo(props) {
    const [premios, setPremios] = useState('');
    const [tipoLink, setTipoLink] = useState('Normal'); // <-- nuevo estado
    const navigate = useNavigate();

    const handleCrear = async () => {
        try {
            const response = await axios.post('https://backend.eldenguee.com/solicitudes', {
                premios,
                tipoLink   // <-- enviar al backend
            });

            const { id } = response.data;
            navigate(`/tipeos/${id}`);
        } catch (error) {
            console.error('Error al crear sorteo:', error);
            alert('Hubo un error al crear el sorteo.');
        }
    };

    return (
        <Nlayout>
            <Box p={4}>
                <Card>
                    <CardContent>
                        <Typography variant="h5" gutterBottom>Crear Link</Typography>

                        <TextField
                            fullWidth
                            type="number"
                            label="Cantidad de premios"
                            margin="normal"
                            value={premios}
                            onChange={(e) => setPremios(e.target.value)}
                        />

                        {/* SELECT TIPO DE LINK */}
                        <FormControl fullWidth margin="normal">
                            <InputLabel id="tipo-link-label">Tipo de Link</InputLabel>
                            <Select
                                labelId="tipo-link-label"
                                value={tipoLink}
                                label="Tipo de Link"
                                onChange={(e) => setTipoLink(e.target.value)}
                            >
                                <MenuItem value="Normal">Normal</MenuItem>
                                <MenuItem value="Instagram">Instagram</MenuItem>
                            </Select>
                        </FormControl>

                        <Button variant="contained" color="primary" fullWidth onClick={handleCrear}>
                            Crear
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        </Nlayout>
    );
}

export default Paneltipeo;
